"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _icons = require("../../../static/icons/icons");

var _style = require("./style");

var onSocialClick = function onSocialClick(url) {
  return window.open(url, '_blank');
};

var AltFooter = function AltFooter(_ref) {
  var style = _ref.style,
      links = _ref.links,
      social = _ref.social,
      copyright = _ref.copyright;
  return _react["default"].createElement(_style.Container, style, _react["default"].createElement(_style.Logo, null, _react["default"].createElement(_Icon["default"], {
    icon: _icons.ICONS.BOB,
    width: 58,
    height: 32,
    viewBox: "0 229 1024 564"
  })), _react["default"].createElement(_style.Links, null, links.map(function (link) {
    return _react["default"].createElement(_style.Link, {
      key: link.url,
      href: link.url,
      target: "_blank"
    }, link.text);
  })), _react["default"].createElement(_style.Social, null, social.map(function (_ref2) {
    var icon = _ref2.icon,
        url = _ref2.url;
    return _react["default"].createElement(_Icon["default"], {
      key: url,
      icon: icon,
      size: 24,
      handleClick: function handleClick() {
        return onSocialClick(url);
      }
    });
  })), _react["default"].createElement(_style.Copyright, null, _react["default"].createElement(_style.Link, {
    href: copyright.url,
    target: "_blank"
  }, "Bob.io"), ' ', "\xA9", ' ', new Date().getFullYear(), ' ', copyright.text));
};

AltFooter.propTypes = {
  style: _propTypes["default"].shape({
    background: _propTypes["default"].string,
    color: _propTypes["default"].string
  }).isRequired,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string,
    url: _propTypes["default"].string
  })).isRequired,
  social: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].string,
    url: _propTypes["default"].string
  })).isRequired,
  copyright: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    text: _propTypes["default"].string
  }).isRequired
};
AltFooter.defaultProps = {};
var _default = AltFooter;
exports["default"] = _default;